import { trackMixpanelEvent } from '../utils/general';

export const TRANSLATION_KEY = 'STATIC.PAGES.ANALYSIS_CHAT.SLACK';

const SLACK_AGENT_BASE = 'interactive-service/slack-agent';

export const SLACK_AGENT_PATHS = {
    STATUS: `${SLACK_AGENT_BASE}/status`,
    INSTALL_START: `${SLACK_AGENT_BASE}/install/start`,
    LINK_START: `${SLACK_AGENT_BASE}/link/start`,
    LINK_CONFIRM: `${SLACK_AGENT_BASE}/link/confirm`,
    LINK: `${SLACK_AGENT_BASE}/link`,
};

export const RESULT_PARAM = 'slack_result';
export const ERROR_PARAM = 'slack_error';
export const LINK_TOKEN_PARAM = 'slack_link_token';
export const SLACK_URL_PARAMS = [RESULT_PARAM, ERROR_PARAM, LINK_TOKEN_PARAM];

export const CONNECT_RESULTS = {
    INSTALLED: 'installed',
    LINKED: 'linked',
};

export const WORKSPACE_STATUS = {
    ACTIVE: 'active',
    REVOKED: 'revoked',
};

export const CONNECT_ERROR_KEYS = {
    authorization_not_completed: 'NOT_COMPLETED',
    session_expired: 'SESSION_EXPIRED',
    state_expired: 'STATE_EXPIRED',
    not_entitled: 'NOT_ENTITLED',
    workspace_conflict: 'WORKSPACE_CONFLICT',
    organization_has_workspace: 'ORGANIZATION_HAS_WORKSPACE',
    workspace_not_connected: 'WORKSPACE_NOT_CONNECTED',
    already_linked: 'ALREADY_LINKED',
    incomplete_authorization: 'INCOMPLETE_AUTHORIZATION',
};
export const GENERIC_ERROR_KEY = 'FAILED';

export const INVITE_ERROR_KEYS = {
    404: 'INVITE_EXPIRED',
    409: 'ALREADY_LINKED',
};

export const toastKey = key => `${TRANSLATION_KEY}.TOASTS.${key}`;

export const connectErrorToastKey = code => toastKey(CONNECT_ERROR_KEYS[code] ?? GENERIC_ERROR_KEY);

export const TOAST_AUTO_CLOSE_MS = 6000;

export const SLACK_AGENT_EVENT_PREFIX = 'Slack Agent';

export const SLACK_AGENT_EVENTS = {
    INSTALL_CLICKED: 'Install Clicked',
    LINK_CLICKED: 'Link Clicked',
    WORKSPACE_INSTALLED: 'Workspace Installed',
    ACCOUNT_LINKED: 'Account Linked',
    ACCOUNT_UNLINKED: 'Account Unlinked',
    INVITE_OPENED: 'Invite Opened',
};

export const trackSlackAgentEvent = (eventName, params) =>
    trackMixpanelEvent(SLACK_AGENT_EVENT_PREFIX, eventName, params);
